import React from 'react';
import { styled } from '@mui/system';

const ImgPlaceholder = styled('img')(() => ({
  display: 'block',
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
  objectFit: 'cover',
  filter: 'brightness(0.3)'
}));

const imageUrl = '/images/video_placeholder.webp';

const preloadImage = (url) => {
  const img = new Image();
  img.src = url;
};

preloadImage(imageUrl);

const VideoPlaceholder = () => {
  return (
    <ImgPlaceholder
      src={imageUrl}
      srcSet={`${imageUrl} 480w, ${imageUrl} 800w, ${imageUrl} 1200w`}
      sizes="(max-width: 600px) 480px, (max-width: 1200px) 800px, 1200px"
      alt="Video placeholder"
    />
  );
};

export default VideoPlaceholder;
